
import { Component, Vue } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import StepsHeader from './StepsHeader.vue'
import StepsOne from './StepsOne/index.vue'
import StepsTwo from './StepsTwo/index.vue'
import StepsThree from './StepsThree/index.vue'
import StepsFour from './StepsFour/index.vue'
import StepsFive from './StepsFive/index.vue'
import StepsSix from './StepsSix/index.vue'

@Component({
  components: {
    StepsOne,
    StepsTwo,
    StepsThree,
    StepsHeader,
    StepsFour,
    StepsFive,
    StepsSix,
  },
})
export default class JoinSteps extends Vue {
  @State step!: number
  @Mutation back!: Function
  @Mutation forward!: Function

  componentsMap: any = {
    '1': 'StepsOne',
    // '2': 'StepsTwo',
    '2': 'StepsThree',
    '3': 'StepsFour',
    '4': 'StepsFive',
    '5': 'StepsSix',
  }

  created() {
    const { NODE_ENV, TARGET } = process.env
    if (NODE_ENV === 'development' || TARGET === 'test-build') {
      (window as any).forward = this.forward
    }
  }
}
